/* external_link.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 64 64" preserveAspectRatio="none">
             <g>
                <g>
                    <g>
                        <path class="foreground-gl" d="M61.7,10.8l-8.4-8.5C51.7,0.8,49.7,0,47.6,0s-4.1,0.8-5.6,2.3l-8.8,8.8l5.7,5.7L47.6,8l8.4,8.4L33.6,38.9l-4.7-4.7
                            l-5.7,5.7l4.7,4.7c1.5,1.5,3.5,2.3,5.6,2.3s4.1-0.8,5.6-2.3l22.5-22.5C64.8,19,64.8,13.9,61.7,10.8z"/>
                    </g>
                </g>
                <g>
                    <g>s
                        <path class="foreground-gl" d="M16.4,56L8,47.6L29.8,26l4.7,4.7l5.7-5.7l-4.7-4.7C34,18.8,32,18,29.8,18s-4.1,0.8-5.6,2.3L2.3,41.9
                            c-3.1,3.1-3.1,8.2,0,11.3l8.4,8.5c1.5,1.5,3.5,2.3,5.6,2.3s4.1-0.8,5.6-2.3l7.9-8L24.3,48L16.4,56z"/>
                    </g>
                </g>
            </g>
		</svg>`
};
